<template>
    <TextLineLayout
        ref="refLines"
        v-for="(pos, i) in positions"
        :text="text"
        :bounds="textBounds"
        :position="pos"
        :key="`textLine${i}`"
        :dir="dir"
        :debug="false"
        :layer="LAYER_BG"
        :options="{
            ...(i === highlightIndex ? { strokeWidth: 0, fillOpacity: 1 } : {}),
        }"
    />
</template>

<script setup>
    import { computed, ref } from 'vue';

    import { useThreeObject } from '@resn/gozer-vue';
    import gsap from '@resn/gsap';

    import TextLineLayout from './TextLineLayout.vue';
    import { useBounds } from '~/components/gl/Bounds';
    import { LAYER_BG } from '~/core/constants';

    defineProps({
        highlightIndex: { default: 2 },
    });

    const visible = ref(false);

    const dir = ref(-1);
    const totalLines = 5;
    const centerIndex = Math.floor(totalLines / 2);

    const text = ref('Chase ');
    const positions = ref([]);
    const refLines = ref([]);

    useThreeObject(null, { name: 'TextRows', props: { v: visible } });

    const bounds = useBounds((val) => resize(val));

    const textBounds = computed(() => {
        const { width, height } = bounds;
        const expandedHeight = height * 1.35;
        const textHeight = expandedHeight / totalLines;
        const textWidth = width;
        return { width: textWidth, height: textHeight };
    });

    const totalHeight = computed(() => textBounds.value.height * totalLines);

    positions.value = new Array(totalLines).fill().map((_, i) => ({ x: 0, y: 0 }));

    let tl;
    const show = ({ delay = 0 } = {}) => {
        tl?.kill();

        tl = new gsap.timeline({
            delay,
            onStart: () => (visible.value = true),
            onComplete: () => (visible.value = false),
            onUpdate: () => {
                refLines.value.forEach((line, i) => line.updateLetters());
            },
        });

        const inDur = 0.8;
        const outDur = 0.2;

        tl.addLabel('start', 0);
        tl.addLabel('end', inDur);

        refLines.value.forEach((line, i) => {
            const { object } = line;

            const newIndex = centerIndex - i;
            const y = newIndex * textBounds.value.height;

            tl.fromTo(
                object.position,
                { y: 0 },
                { y, duration: inDur, ease: 'power4.out' },
                'start'
            );
            tl.fromTo(
                object.scale,
                { x: 0.8, y: 0.8, z: 0.8 },
                { x: 1, y: 1, z: 1, duration: inDur, ease: 'power4.out' },
                'start'
            );
            tl.to(object.position, { y: 0, duration: outDur, ease: 'power2.in' }, `end`);
            tl.to(
                object.scale,
                { x: 0.9, y: 0.9, z: 0.9, duration: outDur, ease: 'power2.in' },
                `end`
            );

            const { letters } = line.text;

            tl.set(letters, { alpha: 1 }, 'start');
            tl.to(letters, { alpha: 0, duration: 0.2 }, 'end');
        });

        return tl;
    };

    const resize = ({ width, height }) => {
        // positions.value.forEach((pos, i) => {
        //     const newIndex = centerIndex - i;
        //     const y = newIndex * textBounds.value.height;
        //     pos.y = y;
        // });
    };

    defineExpose({ show });
</script>
